import { createContext } from "react";

const TenantContext = createContext();

export default TenantContext;
